import packageJson from '../../package.json'

export const appName = packageJson.name
export const appVersion =
  process.env.STORYBOOK === 'true' ? '9.9.9' : packageJson.version
